const deleteBoard = boardRef => {
  return boardRef
    .delete()
}

export default deleteBoard
